<template>
    <unicom-cartao class="cartao-aplicacao" :estilo="objetoEstilo">
        <div slot="body" class="corpo">
            <unicom-linha justificarItem="between">
                <unicom-coluna  lg="10" md="8" :sm="12" alinhamento="center" class="linha-cartao">
                    <h2 class="fonte-secundaria negrito tituloCartao">{{ nomeDaAplicacao }}</h2>
                </unicom-coluna>
                <unicom-coluna lg="2" md="4" :sm="12" class="linha-cartao">
                    <unicom-botao :bloco="true" :altura="40" @click="$emit('acessar')">ACESSAR</unicom-botao>
                </unicom-coluna>
            </unicom-linha>
            <unicom-linha justificarItem="between">
                <unicom-coluna md="12" sm="12">
                    <p class="fonte-secundaria descricao">{{ descricao }}</p>
                </unicom-coluna>
            </unicom-linha>
        </div>
    </unicom-cartao>
</template>

<script>
export default {
    props: {
        nomeDaAplicacao: {
            type: String,
            required: true
        },

        descricao: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            objetoEstilo: {
                paddingTop: 15 + "px",
                paddingBottom: 15 + "px"
            }
        };
    }
};
</script>

<style lang="scss" scoped>
.cartao-aplicacao {
    margin-top: 15px;

    & .linha-cartao{
        margin-bottom: 12px;
    }

    & .tituloCartao {
        color: #60656c;
    }

    & .descricao {
        color: #9e9e9e;
    }
    & .corpo {
        min-height: 40px;
    }
}
</style>
